import {BASE_URL} from "../utils/urls";
import { LOGIN_SUCCESS,LOGOUT } from '../Constant/authConstant'


export const loginRequest = () => {
    return {
        type: "LOGIN_REQUEST"
    }
};

export const loginSuccess = data => {
    return {
        type: LOGIN_SUCCESS,
        payload: data
    }
};

export const loginFailure = error => {
    return {
        type: "LOGIN_FAILURE",
        payload: error
    }
};

export const sendOtpSuccess = data => {
    return {
        type: "SEND_OTP_SUCCESS",
        payload: data
    }
};

export const sendOtpFailure = error => {
    return {
        type: "SEND_OTP_FAILURE",
        payload: error
    }
};
export const verifySuccess = data => {
    return {
        type: "LOGIN_SUCCESS",
        payload: data
    }
};

export const verifyFailure = error => {
    return {
        type: "VERIFY_OTP_FAILURE",
        payload: error
    }
};
export const logout = () => {
    return {
        type: LOGOUT,
    }
};

export function login(data) {
    return dispatch => {

        let myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

        let urlencoded = new URLSearchParams();
        urlencoded.append("contact", data.contact);
        urlencoded.append("password",data.password)
        
        let requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: urlencoded,
            redirect: 'follow'
        };
        return fetch(BASE_URL+'/user/login', requestOptions)
        .then(response => response.json())
        .then(response => {
            // // console.log(response.user.user.userType==="admin")
            if(response.user && response.user.user.userType[0] ==='admin'){
                dispatch(loginSuccess(response.user.user))
            }else if(response.user && response.user.user.userType[0] ==='dc'){
                dispatch(loginSuccess(response.user.user))
            }else if(response.user && response.user.user.userType[0] ==='qc'){
                dispatch(loginSuccess(response.user.user))
            }else if(response.user && response.user.user.userType[0] ==='trainer'){
                dispatch(loginSuccess(response.user.user))
            }else if(response.user && response.user.user.userType[0] ==='regional_coordinator'){
                dispatch(loginSuccess(response.user.user))
            }else if(response.user && response.user.user.userType[0] ==='client'){
                dispatch(loginSuccess(response.user.user))
            }
            return response
        })
        .catch((error) => {
            const errorMessage = error.response;
            dispatch(loginFailure(errorMessage))
        });
    }
}
export function sendOtp(data) {
    return dispatch => {
        let myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

        let urlencoded = new URLSearchParams();
        urlencoded.append("contactNo", data);
        let requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: urlencoded,
            redirect: 'follow'
        };
        return fetch(BASE_URL+'/user/sendOtp', requestOptions)
            .then(response => response.json())
            .then(response => {
                dispatch(sendOtpSuccess(response))
            })
            .catch((error) => {
                const errorMessage = error.response.data.error;
                dispatch(sendOtpFailure(errorMessage))
            });
    }
}

export function verifyOtp(data) {
    return dispatch => {
        let myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

        let urlencoded = new URLSearchParams();
        urlencoded.append("contactNo", data.contactNo);
        urlencoded.append("newLoginOtp", data.newLoginOtp);
        let requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: urlencoded,
            redirect: 'follow'
        };
        return fetch(BASE_URL+'/user/verifyOTP', requestOptions)
            .then(response => response.json())
            .then(response => {
                if(response.user.userRole==='Driver' || response.user.userRole==='Traveller' ){
                    dispatch(verifySuccess(response))
                }
                return response
            })
            .catch((error) => {
                dispatch(verifyFailure(error))
            });
    }
}
export function userLogout() {
    return dispatch => {
       localStorage.clear();
        dispatch(logout())
    }
}
